var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-lg-row align-center header"},[_c('h1',{staticClass:"header-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_vm._t("title")],2),_c('div',[_vm._t("latestUpdate")],2),_c('div',{staticClass:"w-100"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }